/**
 * Objectが空かどうか
 * @param obj {Object}
 * @return {Boolean}
 * *
 */
export const isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length;

